import { format } from "date-fns";

import {
  defaultValueActsFilterIProps,
  defaultValueCamerasFilterIProps,
} from "~/entity/Ivideon/model/schema";

type AnyFilterProps =
  | defaultValueActsFilterIProps
  | defaultValueCamerasFilterIProps;

export const cleanFilters = <T extends AnyFilterProps>(filters: T) => {
  return Object.entries(filters).reduce(
    (acc, [key, value]) => {
      const isObjectWithValue =
        typeof value === "object" && value !== null && "value" in value;

      const hasValue = isObjectWithValue
        ? !!(value as any).value
        : value !== "" && value !== null && value !== undefined;

      if (hasValue) {
        if ((key === "dateFrom" || key === "dateTo") && value) {
          acc[key] = format(new Date(value), "yyyy-MM-dd");
        } else if (isObjectWithValue) {
          acc[key] = (value as any).value;
        } else {
          acc[key] = value;
        }
      }

      return acc;
    },
    {} as Record<string, any>,
  );
};
